import { CmsGuestCheckout } from './cms-guest-checkout.interface';
import { CmsSignIn } from './cms-sign-in.interface';

export interface CmsLandingPage extends CmsGuestCheckout, CmsSignIn {
  pageTitle: string;
}
